import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { ButtonSubmit, Form } from '@anytag/shared-atoms';
import { useDeepCompareEffect } from '@anytag/shared-hooks';
import { CampaignInformation, CastingInformation, Tracking } from './formSections';
import { EngagementCampaignFormValues } from './types';
import { getDisabledFields } from './utils';

export const Template = () => {
  const { t } = useTranslation();
  const {
    reset,
    formState: { isSubmitting, defaultValues }
  } = useFormContext<EngagementCampaignFormValues>();

  useDeepCompareEffect(() => {
    reset(defaultValues);
  }, [defaultValues]);

  const disabledFields = getDisabledFields(defaultValues?.status);

  return (
    <>
      <Form.Body className="form-container">
        <CampaignInformation disabledFields={disabledFields} />
        <Form.Line className="my-6" />
        <CastingInformation disabledFields={disabledFields} />
        <Form.Line className="mt-3 mb-6" />
        <Tracking disabledFields={disabledFields} />
      </Form.Body>

      <Form.Footer>
        <ButtonSubmit title={t('Button.Save')} loading={isSubmitting} />
      </Form.Footer>
    </>
  );
};
